const Navigation = () => {
  return (
    <nav className="hidden md:flex space-x-6">
      <a href="#about" className="hover:text-blue-600 transition-colors">
        About
      </a>
      <a href="#skills" className="hover:text-blue-600 transition-colors">
        Skills
      </a>
      <a
        href="#certifications"
        className="hover:text-blue-600 transition-colors"
      >
        Certifications
      </a>
      <a href="#contact" className="hover:text-blue-600 transition-colors">
        Contact
      </a>
    </nav>
  );
};

export default Navigation;
